import { axiosRef } from '../../../api';
import { formatDateWithDashes } from '../../../utils/helper';
import {
  AdminJobQueryPayload,
  GeneralJob,
  GeneralJobQueryPayload,
} from '../interfaces';
import { ProjectStatus } from '../../interfaces';

export default async function getJobs(
  payload: GeneralJobQueryPayload | AdminJobQueryPayload,
  isAdmin: boolean,
  setLoading: (loading: boolean) => void,
) {
  setLoading(true);

  let url = `${isAdmin ? 'admin/': ''}jobs?is_pagination=true&`;

  if (payload && payload.page !== undefined) {
    url += `page=${payload.page}&`;
  }
  if (payload && payload.pageSize !== undefined) {
    url += `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.startDate && payload.endDate) {
    const start = formatDateWithDashes(payload.startDate);
    const end = formatDateWithDashes(payload.endDate);
    url += `start_date=${start}&end_date=${end}&`;
  }
  if (payload && payload.username && payload.username !== '') {
    url += `username=${payload.username}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url += `search=${payload.search}&`;
  }
  if (payload && payload.status !== undefined && payload.status !== ProjectStatus.ALL) {
    url += `status=${payload.status}&`;
  }
  if (payload && payload.projectCode && payload.projectCode !== '') {
    url += `project_code=${payload.projectCode}&`;
  }
  if (payload && (payload as AdminJobQueryPayload).account) {
    url += `account=${(payload as AdminJobQueryPayload).account}`;
  }

  try {
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const jobs = response.data.content.data.map((datum: any): GeneralJob => ({
        id: datum.id,
        creationDate: datum.creation_date,
        username: datum.username,
        bbeNumber: datum.bbe_number,
        statusName: datum.status_name,
        project: datum.project,
        referenceOne: datum.reference_one,
        referenceTwo: datum.reference_two,
        deprecateOldProject: datum.deprecated_old_project,
        purchaseOrder: datum.purchase_order,
        bcCustomerCode: datum.bc_customer_code,
        bcCustomerName: datum.bc_customer_name,
      }));
      return {
        jobs,
        count: response.data.content.count,
        pages: response.data.content.pages,
      };
    }
    setLoading(false);
    return {
      jobs: [],
      count: 0,
      pages: 0,
    };
  } catch (error) {
    setLoading(false);
    return {
      jobs: [],
      count: 0,
      pages: 0,
    };
  }
}
